import React from 'react';

import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { NorthEastOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export default function ContainerYieldSidebar() {
  const platformId = useCurrentPlatformId();
  return (
    <Box>
      <Typography paragraph>
        This is where your nested template's content blocks will live. Add blocks around this placeholder that you would
        like to be shared across multiple templates (logos, copyright information, etc.).
      </Typography>
      <Typography paragraph>
        When you are ready to use this layout, simply select the layout from the 'Styles' tab on a template.
      </Typography>
      <ButtonLink
        size="small"
        endIcon={<NorthEastOutlined fontSize="small" />}
        href={`/o/${platformId}/templates`}
        target="_blank"
        sx={{ ml: -0.5, mt: 1.5 }}
      >
        Open templates
      </ButtonLink>
    </Box>
  );
}
